// React
import { connect } from 'react-redux'
// External libs
import { get } from 'lodash'
// Components
import ToppingBoxesList from './ToppingBoxesList'

const mapStateToProps = ({ menuReducer: { filter, menus } }) => {
  const selectedStoreId = +filter.selectedStoreId
  const products = get(menus, [selectedStoreId, 'products'], [])
  const toppingCategories = get(menus, [selectedStoreId, 'toppings'], [])
  return { products, toppingCategories }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(ToppingBoxesList)
